export default __webpack_public_path__ + "static/media/banner.b356a217.png";